import styled from '@emotion/styled';
import React from 'react';
import { Header, IconButton, TextButton } from '../components/atoms';
import { Notifications } from '../components/templates';
import { useUserContext } from '../contexts/UserContext';
import theme from '../styles/theme';

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.xl};
`;

const HeaderLeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.s};
`;

const NotificationsPage = () => {
  const { handleGetNotifications, handleReadAllNotifications } =
    useUserContext();

  return (
    <>
      <HeaderWrapper>
        <Header>알림</Header>
        <HeaderLeftSide>
          <IconButton
            name="refresh-cw"
            size={theme.iconSizes.m}
            color={theme.colors.gray700}
            style={{ display: 'block' }}
            onClick={handleGetNotifications}
          />
          <TextButton onClick={handleReadAllNotifications}>
            모두 읽음 처리하기
          </TextButton>
        </HeaderLeftSide>
      </HeaderWrapper>
      <Notifications />
    </>
  );
};

export default NotificationsPage;
